import { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const handleNavClick = (href: string) => (e: React.MouseEvent) => {
    e.preventDefault();
    setIsMenuOpen(false);

    if (href.startsWith('http')) {
      window.open(href, '_blank', 'noopener,noreferrer');
      return;
    }

    if (href.includes('#')) {
      const [pathPart, hashPart] = href.split('#');
      const targetPath = pathPart || '/';
      const targetHash = '#' + hashPart;

      if (location.pathname === targetPath) {
        const el = document.querySelector(targetHash);
        if (el) el.scrollIntoView({ behavior: 'smooth' });
      } else {
        navigate(targetPath + targetHash);
        setTimeout(() => {
          const el = document.querySelector(targetHash);
          if (el) el.scrollIntoView({ behavior: 'smooth' });
        }, 150);
      }
    } else {
      navigate(href);
    }
  };

  const navItems = [
    { name: 'ホーム', href: '/' },
    { name: '音への取り組み', href: '/#sound-philosophy' },
    { name: '箕面音風景百選', href: '/minoh-soundscapes' },
    { name: '会社概要', href: '/#about' },
    { name: 'スタジオ', href: '/#studio' },
    { name: 'サービス', href: '/#services' },
    { name: '制作実績', href: '/#works' },
    { name: 'お問い合わせ', href: '/#contact' }
  ];

  return (
    <header className="bg-[#0a0a0b]/90 backdrop-blur-md sticky top-0 z-50 border-b border-white/10">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          <div className="flex items-center cursor-pointer" onClick={() => navigate('/')}>
            <img
              src="/images/brand/logo.jpg"
              alt="WakuWaku Logo"
              className="h-10 w-10 mr-3"
            />
            <h1 className="text-2xl font-bold text-teal-400" style={{ fontFamily: '"Fredoka One", cursive' }}>
              合同会社WakuWaku
            </h1>
          </div>

          <nav className="hidden md:flex space-x-7">
            {navItems.map((item) => (
              <a
                key={item.name}
                href={item.href}
                onClick={handleNavClick(item.href)}
                className="text-zinc-300 hover:text-teal-300 transition-colors cursor-pointer whitespace-nowrap text-sm"
              >
                {item.name}
              </a>
            ))}
          </nav>

          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden w-6 h-6 flex items-center justify-center cursor-pointer text-white"
          >
            <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-xl`}></i>
          </button>
        </div>

        {isMenuOpen && (
          <div className="md:hidden py-4 border-t border-white/10">
            {navItems.map((item) => (
              <a
                key={item.name}
                href={item.href}
                onClick={handleNavClick(item.href)}
                className="block py-2 text-zinc-300 hover:text-teal-300 transition-colors cursor-pointer"
              >
                {item.name}
              </a>
            ))}
          </div>
        )}
      </div>
    </header>
  );
}